import Event from '../../core/Event';

export default class OrderDocumentGetSucceed extends Event {
    public static type = 'OrderDocumentGetSucceed';

    constructor() {
        super(OrderDocumentGetSucceed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDocumentGetSucceed.ts